<div #beneficiosPage data-section-id="beneficios-page-section" data-section-name="Beneficios Page">
  <app-benefits-hero></app-benefits-hero>
  <app-exclusive-discounts></app-exclusive-discounts>
  <app-permanent-discounts></app-permanent-discounts>
  <app-catalog-offers></app-catalog-offers>
  <app-cta-banner></app-cta-banner>
</div>

<!-- Botones flotantes reutilizables -->
<app-floating-buttons></app-floating-buttons>

